import { render, staticRenderFns } from "./CategoryTemplatesTable.vue?vue&type=template&id=90a48ac0&lang=pug"
import script from "./CategoryTemplatesTable.vue?vue&type=script&lang=js"
export * from "./CategoryTemplatesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports